<div
  *ngIf="showFilters"
  class="flex-wrap rounded-2xl bg-white border !border-slate-200/70 p-2.5 md:p-3 mb-3 space-y-2 md:space-y-0 md:flex md:items-center md:gap-2"
>
  <div class="flex items-center gap-1.5 flex-wrap">
    <div class="flex flex-row flex-wrap md:items-center gap-2 md:gap-2">
      <div class="relative flex-1 min-w-[143px] w-full">
        <select
          class="w-full appearance-none pl-3 pr-8 py-2 rounded-lg border border-slate-200/70 bg-slate-50/60 hover:bg-white text-[14px] text-slate-700 focus:outline-none focus:border-[var(--primary-color)] cursor-pointer transition-colors"
          #roleSelect
          (change)="onRoleChange(roleSelect.value)"
        >
          <option value="all">{{ "anyRole" | transloco }}</option>
          <option value="User">User</option>
          <option value="Manager">PartnerManager</option>
          <option value="Admin">Admin</option>
          <option value="Superadmin">Superadmin</option>
        </select>

        <span
          class="pointer-events-none absolute right-2.5 top-3 text-slate-400 flex items-center"
        >
          <igntr-icon name="chevron"></igntr-icon>
        </span>
      </div>
      <div class="relative flex-1 min-w-[143px] w-full">
        <select
          class="w-full appearance-none pl-3 pr-8 py-2 rounded-lg border border-slate-200/70 bg-slate-50/60 hover:bg-white text-[14px] text-slate-700 focus:outline-none focus:border-[var(--primary-color)] cursor-pointer transition-colors"
          #groupSelect
          (change)="filterByGroup(groupSelect.value)"
        >
          <option value="all">{{ "anyGroup" | transloco }}</option>
          <option value="no-group">{{ "withoutGroup" | transloco }}</option>

          <option *ngFor="let group of userGroups" [value]="group.value">
            {{ group.label }}
          </option>
        </select>

        <span
          class="pointer-events-none absolute right-2.5 top-3 text-slate-400 flex items-center"
        >
          <igntr-icon name="chevron"></igntr-icon>
        </span>
      </div>
    </div>
    <div class="flex items-center gap-1.5">
      <button
        class="inline-flex px-2.5 py-2 rounded-lg text-[14px] text-slate-500 hover:text-slate-900 items-center gap-1.5"
        (click)="toggleSaveFilters()"
      >
        <span class="opacity-70 flex items-center"
          ><igntr-icon
            [name]="checked ? 'bookmarkFilled' : 'bookmark'"
          ></igntr-icon>
        </span>
        {{ "saveFilter" | transloco }}
      </button>
    </div>
  </div>
</div>
<div
  class="rounded-2xl bg-white border !border-slate-200/70 overflow-hidden overflow-x-auto"
>
  <div
    class="grid grid-cols-[36px_1.5fr_20px] sm:grid-cols-[36px_minmax(250px,1.5fr)_1fr_60px] lg:grid-cols-[36px_minmax(250px,1.5fr)_minmax(170px,1fr)_2fr_60px] items-center px-4 py-2.5 text-[14px] font-semibold tracking-[0.08em] !text-slate-500 border-b !border-slate-200/70 !bg-slate-50/60"
  >
    <p-checkbox
      [binary]="true"
      [ngModel]="isAllSelected()"
      (onChange)="onToggleAll($event.checked)"
    ></p-checkbox><span
      ><button
        class="text-left inline-flex items-center gap-1 hover:!text-slate-900"
        (click)="toggleSort('name')"
      >
        {{ "name" | transloco }}
        <span
          class="text-[14px]"
          [ngClass]="sortField === 'name' ? 'text-slate-700' : 'text-slate-300'"
        >
          {{ sortField === "name" && sortDir === 1 ? "▲" : "▼" }}
        </span></button></span
    ><span
      ><button
        class="hidden sm:inline-flex text-left items-center gap-1 hover:!text-slate-900"
        (click)="toggleSort('roles')"
      >
        {{ "roles" | transloco }}
        <span
          class="text-[14px]"
          [ngClass]="
            sortField === 'roles' ? 'text-slate-700' : 'text-slate-300'
          "
        >
          {{ sortField === "roles" && sortDir === 1 ? "▲" : "▼" }}
        </span></button></span
    ><span
      ><button
        class="hidden lg:inline-flex text-left items-center gap-1 hover:!text-slate-900"
        (click)="toggleSort('groups')"
      >
        {{ "groups" | transloco }}
        <span
          class="text-[14px]"
          [ngClass]="
            sortField === 'groups' ? 'text-slate-700' : 'text-slate-300'
          "
        >
          {{ sortField === "groups" && sortDir === 1 ? "▲" : "▼" }}
        </span></button></span
    ><span></span>
  </div>

  <div class="bg-white overflow-hidden">
    <div
      *ngFor="let user of filteredUsers"
      class="grid grid-cols-[36px_1.5fr_20px] sm:grid-cols-[36px_minmax(250px,1.5fr)_1fr_60px] lg:grid-cols-[36px_minmax(250px,1.5fr)_minmax(170px,1fr)_2fr_60px] items-center px-4 py-3 border-b border-slate-100 hover:bg-[oklch(0.985_0.008_47)] transition"
    >
      <div (click)="$event.stopPropagation()">
        <p-checkbox
          [binary]="true"
          [ngModel]="selectedUsers.includes(user)"
          (onChange)="toggleUser(user)"
        ></p-checkbox>
      </div>

      <div class="flex items-center gap-2 min-w-0 pr-4">
        <app-entity-avatar-init
          [img]="user.imagePath"
          [name]="user.name"
          [surname]="user.surname"
        ></app-entity-avatar-init>

        <div class="min-w-0">
          <a
            [routerLink]="['/users', user.id]"
            class="inline-block max-w-[180px] w-full text-[14px] font-medium !text-slate-900 truncate vertical-align-middle"
            [title]="user.name + ' ' + user.surname"
          >
            {{ user.name }} {{ user.surname }}
          </a>

          <div class="text-[12px] text-slate-500 truncate">
            {{ user.email }}
          </div>
        </div>
      </div>

      <div
        class="text-[14px] text-slate-600 truncate pr-4 hidden sm:block"
        pTooltip="{{ user.rolesNames.join(', ') }}"
      >
        {{ user.rolesNames.join(", ") }}
      </div>

      <div
        class="text-[14px] text-slate-600 truncate pr-4 hidden lg:block"
        pTooltip="{{ user.groupsNames.join(', ') }}"
      >
        {{ user.groupsNames.join(", ") }}
      </div>

      <div class="flex justify-end">
        <button
          [matMenuTriggerFor]="menu"
          class="w-7 h-7 rounded hover:bg-slate-100 text-slate-400 hover:text-slate-700 flex items-center justify-center"
        >
          <igntr-icon name="dots"></igntr-icon>
        </button>

        <mat-menu #menu="matMenu">
          <button
            mat-menu-item
            [routerLink]="['/users', user.id]"
            title="{{ 'edit' | transloco }}"
            class="!min-h-[36px] !px-3 !py-2 !rounded-md !text-[14px] !font-medium !text-slate-700"
          >
            {{ "edit" | transloco }}
          </button>
          <button
            mat-menu-item
            class="!min-h-[36px] !px-3 !py-2 !rounded-md !text-[14px] !font-medium !text-red-600"
            (click)="actionConfirmation = user"
            title="{{ 'delete' | transloco }}"
          >
            {{ "delete" | transloco }}
          </button>
        </mat-menu>
      </div>
    </div>

    <div *ngIf="filteredUsers?.length === 0" class="py-16 text-center">
      <div class="text-[14px] text-slate-500">
        {{ "noUsers" | transloco }}
      </div>
    </div>
  </div>
</div>
<app-confirm-delete
  id="deleteusermodal"
  *ngIf="actionConfirmation"
  [deleteCandidate]="actionConfirmation.name"
  (confirm)="handleActionClick(actionConfirmation); actionConfirmation = null"
  (cancel)="actionConfirmation = null"
></app-confirm-delete>
